export default "__VITE_ASSET__DcvcZf2K__"